let contextPath = `${process.env.assetsPublicPath}`;
if (contextPath.lastIndexOf('/') == contextPath.length - 1) {
  contextPath = contextPath.substring(0, contextPath.length - 1);
}


export const CONSTS = {
  contextPath,
  // 返回结果的字段名标志
  RESULT_FLAG: {
    STATUS_FIELD : 'status',
    MSG_FIELD : 'msg'
  },
  // 图片验证码
  CAPTCHA: contextPath + '/captcha',
  // 校验图片验证码
  CHECK_CAPTCHA: contextPath + 'validateCaptcha',
  // 加密密钥
  ENTRY_ACTION: contextPath + '/get-key',
  // 临时sts
  STS: contextPath + '/file/sts',
  // 上传前文件信息
  FILEINFO: contextPath + '/file/addFile',
  // 登录地址
  LOGIN_ACTION: contextPath + '/Login',
  // 退出地址
  LOGOUT_ACTION: contextPath + '/Login',
  // 账户首页
  ACCOUNT_URL: contextPath + '/frame/personal/personal_center'
}


// WEBPACK FOOTER //
// ./src/untils/consts.js